import { AuthClient } from './AuthClient';
import type { AuthClientOptions } from './types';
import { validateCrypto } from './util/utils';

export async function createAuthClient(options: AuthClientOptions) {
  validateCrypto();
  return new AuthClient(options);
}
